export default function formatHMS(s: number): string {
  const hora = Math.floor(s / 3600);
  const minuto = Math.floor((s % 3600) / 60);
  const segundo = (s % 3600) % 60;

  const horaFormated = hora <= 9 ? `0${hora}` : hora;
  const minutsFormated = minuto <= 9 ? `0${minuto}` : minuto;
  const secondsFormated = segundo <= 9 ? `0${segundo}` : segundo;

  const formatado = `${horaFormated}:${minutsFormated}:${secondsFormated}`;
  return formatado;
}
